// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fc-event {\n  height:60px !important;\n}\n\n.fc-daygrid-event-harness {\n  line-height:50px !important;\n}\n", ""]);
// Exports
module.exports = exports;
